import React, { useEffect } from "react";
// react component for creating dynamic tables

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import ReactTable from "react-table";
import AccessibilityIcon from "@material-ui/icons/Accessibility";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import Button from "components/CustomButtons/Button.js";

import { token } from "functions/Helper";
import { agentApi } from "functions/apis";
import { adminApi } from "functions/apis";
import MailOutline from "@material-ui/icons/MailOutline";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  tableContainer: {
    overflowX: "auto",
    "&::-webkit-scrollbar": {
      height: "8px"
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#888",
      borderRadius: "4px"
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#555"
    }
  },
  table: {
    minWidth: "1200px" // Adjust this value based on your table's content
  }
};

const useStyles = makeStyles(styles);

export default function ImpersonateList() {
  const impersonateSignal = React.useRef(new AbortController());

  const [impersonateList, setImpersonateList] = React.useState([]);
  const [pages, setPages] = React.useState(0);
  const [pagination, setPagination] = React.useState({
    pageIndex: 1,
    pageSize: 5
  });
  const [loading, setLoading] = React.useState(false);
  const [userData, setUserData] = React.useState();

  useEffect(() => {
    setLoading(true);
    getProfile();
  }, []);

  useEffect(() => {
    if (userData) {
      getImpersonateList();
    }
  }, [userData, pagination]);

  const getProfile = () => {
    adminApi
      .get("/Profile", {
        signal: impersonateSignal.current.signal
      })
      .then(data => {
        setUserData(data);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleRedirectToAgentPortal = id => {
    agentApi
      .post(`/Impersonate/${id}`, null, {
        signal: impersonateSignal.current.signal
      })
      .then(data => {
        console.log(
          `${process.env.REACT_APP_AGENT_PORTAL_URL}/auth/login?token=${data}`
        );
        window.open(
          `${process.env.REACT_APP_AGENT_PORTAL_URL}/auth/login?token=${data}`,
          "_blank",
          "noopener,noreferrer"
        );
      })
      .catch(err => {
        console.log(err);
      });
  };

  const getImpersonateList = () => {
    setLoading(true);
    agentApi
      .get("/Impersonate", {
        signal: impersonateSignal.current.signal,
        params: {
          filter: {
            searchString: ""
          },
          pagination
        }
      })
      .then(data => {
        setImpersonateList(
          data.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  {(token.is_admin === "True" ||
                    token["agent.impersonations.impersonate"] ===
                      "allowed") && (
                    <Button
                      color="info"
                      className="like"
                      onClick={() => handleRedirectToAgentPortal(record.id)}
                    >
                      <AccessibilityIcon /> IMPERSONATE
                    </Button>
                  )}
                </div>
              )
            };
          })
        );
        setPages(Math.ceil(data.totalRecords / pagination.pageSize));
      })
      .catch(error => console.log(error))
      .finally(() => {
        setLoading(false);
      });
  };

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>IMPERSONATIONS</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              manual
              pages={pages}
              page={pagination.pageIndex - 1}
              pageSize={pagination.pageSize}
              onPageChange={page =>
                setPagination({
                  pageIndex: page + 1,
                  pageSize: pagination.pageSize
                })
              }
              onPageSizeChange={(pageSize, page) => {
                setPagination({ pageSize: pageSize, pageIndex: page + 1 });
              }}
              loading={loading}
              data={impersonateList}
              filterable={false}
              columns={[
                {
                  Header: "Agent Code",
                  id: "agentCode",
                  accessor: d => d.agent.code
                },
                {
                  Header: "Agent Name",
                  id: "agentName",
                  accessor: d => d.agent.name
                },
                {
                  Header: "Actions",
                  accessor: "actions",
                  sortable: false,
                  filterable: false
                }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
